import { AuthService } from '../services/AuthService';
import { appPlatformHeaders } from './constants/appHeaders';

export const getHeaders = (
  additionalHeaders: Record<string, string> = {}
): Record<string, string> => {
  if (AuthService.authToken !== null) {
    return {
      Authorization: `Bearer ${AuthService.authToken}`,
      ...appPlatformHeaders,
      ...additionalHeaders
    };
  } else {
    throw new Error('Пользователь не авторизирован');
  }
};
